exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.message-box .el-tabs__content{\r\n  padding-top: 0;\n}\n.mb-message-mgr{\r\n  color: #161616;\n}\n.mb-message-mgr .el-drawer__header{\r\n  text-align: left;\r\n  -webkit-box-sizing: border-box;\r\n          box-sizing: border-box;\n}\n.mb-message-mgr .el-drawer__body{\r\n  background: #F3F5F8;  \r\n  position: relative;\r\n  overflow: auto;\n}\r\n", ""]);

// exports
